var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIssues(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2495 15.2242V11.002M11.2495 6.77973H11.2602M6.78269 20.502H15.7164C17.5033 20.502 18.3967 20.502 19.0792 20.1568C19.6796 19.8532 20.1677 19.3688 20.4736 18.7729C20.8213 18.0955 20.8213 17.2088 20.8213 15.4353V6.56862C20.8213 4.79512 20.8213 3.90837 20.4736 3.23098C20.1677 2.63514 19.6796 2.1507 19.0792 1.8471C18.3967 1.50195 17.5033 1.50195 15.7164 1.50195H6.78269C4.99579 1.50195 4.10234 1.50195 3.41983 1.8471C2.81948 2.1507 2.33138 2.63514 2.02549 3.23098C1.67773 3.90837 1.67773 4.79512 1.67773 6.56862V15.4353C1.67773 17.2088 1.67773 18.0955 2.02549 18.7729C2.33138 19.3688 2.81948 19.8532 3.41983 20.1568C4.10234 20.502 4.99579 20.502 6.78269 20.502Z",
    stroke: "#EC3434",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssues);
export default __webpack_public_path__ + "static/media/issues.f73ff0d0656b6656acac9b97435f9901.svg";
export { ForwardRef as ReactComponent };